// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/shield-alert.js';

import { paths } from '../generated/shield-alert';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('shield-alert', Original, paths);
